import Component from "@base/Component.js";

/**
 * Shared chrome for every Cockpit section: a titled header with an optional
 * lead paragraph and action buttons, plus the panel body.
 *
 * Subclasses override title()/lead()/actions()/body() rather than render(), so
 * every section lines up visually without repeating the wrapper markup. A
 * subclass that needs different chrome can still override render() outright.
 *
 * All four are expected of every section, and the primary action belongs in
 * actions() — top-right, where the eye goes — not loose in body(). Hero used to
 * put its upload in the body and that alone made its heading row look like a
 * different product (#132).
 *
 * empty() and error() are the shared no-content and failed-load blocks. error()
 * is for every panel; empty() is for the ones that list something, so a section
 * holding a single value (Hero) or a settings form (My Account) reasonably has
 * no use for it. See cockpitSections.js for the conventions across sections.
 */
export default class CockpitPanel extends Component {
  /** Section heading. */
  title() {
    return "";
  }

  /** One-line explanation under the heading; omit by returning "". */
  lead() {
    return "";
  }

  /** HTML for the top-right action area (buttons). */
  actions() {
    return "";
  }

  /** The panel's own content. */
  body() {
    return "";
  }

  render() {
    const lead = this.lead();
    const actions = this.actions();
    return `
      <section class="cockpit-panel">
        <header class="cockpit-panel__head">
          <div class="cockpit-panel__heading">
            <h2 class="cockpit-panel__title">${this.title()}</h2>
            ${lead ? `<p class="cockpit-panel__lead">${lead}</p>` : ""}
          </div>
          ${actions ? `<div class="cockpit-panel__actions">${actions}</div>` : ""}
        </header>
        <div class="cockpit-panel__body">${this.body()}</div>
      </section>`;
  }

  /** Standard "nothing here yet" block, so empty states match across panels. */
  static empty(message) {
    return `<p class="cockpit-empty">${Component.escape(message)}</p>`;
  }

  /** Standard error block for a panel whose fetch failed. */
  static error(message) {
    return `<p class="cockpit-error">${Component.escape(message)}</p>`;
  }
}
